function PurchaseOrderIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 10.6667V1.33333H6V6H10.6667V6.66667C11.1333 6.66667 11.58 6.75333 12 6.9V4L8 0H1.33333C0.593333 0 0 0.593333 0 1.33333V10.6667C0 11.0203 0.140476 11.3594 0.390524 11.6095C0.640573 11.8595 0.979711 12 1.33333 12H6.9C6.75333 11.58 6.66667 11.1333 6.66667 10.6667H1.33333ZM7.33333 1L11 4.66667H7.33333V1ZM13 9.5L9.83333 12.6667L8 10.6667L8.77333 9.89333L9.83333 10.9533L12.2267 8.56L13 9.5Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default PurchaseOrderIcon
